/*
 * @Date: 2023-12-20 14:33:40
 * @Author: jm
 * @LastEditTime: 2023-12-20 14:33:44
 * @LastEditors: jm
 * @FilePath: \MultiplePage-master\src\utils\utils.js
 * @Description: 
 */
import CryptoJS from "crypto-js";
import ab from './common';
const c = ab.a+ab.b
export const utils= {
     getRequest:(name)=>{
    
        var url_string = window.location.href;  
        var params = url_string.split('?')[1]; // 获取?号后面的参数 name=mick&age=20
        if (!params) return null; // 如果无参，返回null
        var vars = params.split("&"); // 将参数分割成数组 ['name=mick', 'age=20']
        var query_string = {};
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("="); // 将参数的key和值进行分割成 ['name', 'mick']
          var key = decodeURIComponent(pair[0]); // 参数key
          var value = decodeURIComponent(pair[1]); // 参数值
          if (name === key) { // 如果匹配到对应key返回
            return value;
          }
        }
        return null;
      },
    jim:(word)=>{
      　　　　　// 更新：这个key的字符位数要求：4的倍数（包含""）
      var key = CryptoJS.enc.Base64.parse(c);//123456789abc这个自己随便写，相当于密钥吧，也可以自己单独用个变量存
      var srcs = CryptoJS.enc.Base64.parse(c);
      var encrypted = CryptoJS.AES.encrypt(word, key, {
        iv:srcs,
        mode:CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7});
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    },
    /*解密*/
    jem:(word)=>{
      var key = CryptoJS.enc.Base64.parse(c);
      //要和加密的密钥一样
      var srcs = CryptoJS.enc.Base64.parse(c);
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        iv:srcs,
        mode:CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7});
      return decrypt.toString(CryptoJS.enc.Utf8);
    }
}